
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const getAuthHeader = (token) => ({ Authorization: `Bearer ${token}` });

export const sharedApi = {
    getLawFirms: async (token) => {
        const res = await axios.get(`${API}/shared/lawfirms`, { headers: getAuthHeader(token) });
        return res.data;
    },

    getTrademarks: async (token, sourceTenantId, { page = 1, pageSize = 25, query = '' } = {}) => {
        const params = {
            source_tenant_id: sourceTenantId,
            page,
            page_size: pageSize,
            query: query || undefined
        };
        const res = await axios.get(`${API}/shared/trademarks`, {
            headers: getAuthHeader(token),
            params
        });
        return res.data;
    },

    getProcedures: async (token, sourceTenantId, { page = 1, pageSize = 25, status = '' } = {}) => {
        const params = {
            source_tenant_id: sourceTenantId,
            page,
            page_size: pageSize,
            status: status || undefined
        };
        const res = await axios.get(`${API}/shared/procedures`, {
            headers: getAuthHeader(token),
            params
        });
        return res.data;
    }
};
